module.exports = __webpack_public_path__ + "static/media/contra-el-borrado-de-las-mujeres-seminario-latam.bc16e054.png";